// Constants
var FirebaseEvents = {
  AD_IMPRESSION: "ad_impression",
  ADD_PAYMENT_INFO: "add_payment_info",
  ADD_TO_CART: "add_to_cart",
  ADD_TO_WISHLIST: "add_to_wishlist",
  APP_OPEN: "app_open",
  BEGIN_CHECKOUT: "begin_checkout",
  CAMPAIGN_DETAILS: "campaign_details",
  ECOMMERCE_PURCHASE: "ecommerce_purchase",
  GENERATE_LEAD: "generate_lead",
  JOIN_GROUP: "join_group",
  LEVEL_END: "level_end",
  LEVEL_START: "level_start",
  LEVEL_UP: "level_up",
  LOGIN: "login",
  POST_SCORE: "post_score",
  PRESENT_OFFER: "present_offer",
  PURCHASE_REFUND: "purchase_refund",
  SEARCH: "search",
  SELECT_CONTENT: "select_content",
  SHARE: "share",
  SIGN_UP: "sign_up",
  SPEND_VIRTUAL_CURRENCY: "spend_virtual_currency",
  TUTORIAL_BEGIN: "tutorial_begin",
  TUTORIAL_COMPLETE: "tutorial_complete",
  UNLOCK_ACHIEVEMENT: "unlock_achievement",
  VIEW_ITEM: "view_item",
  VIEW_ITEM_LIST: "view_item_list",
  VIEW_SEARCH_RESULTS: "view_search_results",
  EARN_VIRTUAL_CURRENCY: "earn_virtual_currency",
  SCREEN_VIEW: "screen_view",
  REMOVE_FROM_CART: "remove_from_cart",
  CHECKOUT_PROGRESS: "checkout_progress",
  SET_CHECKOUT_OPTION: "set_checkout_option",
  ADD_SHIPPING_INFO: "add_shipping_info",
  PURCHASE: "purchase",
  REFUND: "refund",
  SELECT_ITEM: "select_item",
  SELECT_PROMOTION: "select_promotion",
  VIEW_CART: "view_cart",
  VIEW_PROMOTION: "view_promotion"
};
var FirebaseCBEvents = {
  PRODUCT_IMPRESSION: "productImpression",
  PURCHASE_CONFIRMATION: "purchaseConfirmation"
};
var FirebaseParams = {
  AD_FORMAT: "ad_format",
  AD_PLATFORM: "ad_platform",
  AD_SOURCE: "ad_source",
  AD_UNIT_NAME: "ad_unit_name",
  CHARACTER: "character",
  TRAVEL_CLASS: "travel_class",
  CONTENT_TYPE: "content_type",
  CURRENCY: "currency",
  COUPON: "coupon",
  START_DATE: "start_date",
  END_DATE: "end_date",
  EXTEND_SESSION: "extend_session",
  FLIGHT_NUMBER: "flight_number",
  GROUP_ID: "group_id",
  ITEM_CATEGORY: "item_category",
  ITEM_ID: "item_id",
  ITEM_LOCATION_ID: "item_location_id",
  ITEM_NAME: "item_name",
  LOCATION: "location",
  LEVEL: "level",
  LEVEL_NAME: "level_name",
  SIGN_UP_METHOD: "sign_up_method",
  METHOD: "method",
  NUMBER_OF_NIGHTS: "number_of_nights",
  NUMBER_OF_PASSENGERS: "number_of_passengers",
  NUMBER_OF_ROOMS: "number_of_rooms",
  DESTINATION: "destination",
  ORIGIN: "origin",
  PRICE: "price",
  QUANTITY: "quantity",
  SCORE: "score",
  SHIPPING: "shipping",
  TRANSACTION_ID: "transaction_id",
  SEARCH_TERM: "search_term",
  SUCCESS: "success",
  TAX: "tax",
  VALUE: "value",
  VIRTUAL_CURRENCY_NAME: "virtual_currency_name",
  CAMPAIGN: "campaign",
  SOURCE: "source",
  MEDIUM: "medium",
  TERM: "term",
  CONTENT: "content",
  ACLID: "aclid",
  CP1: "cp1",
  ITEM_BRAND: "item_brand",
  ITEM_VARIANT: "item_variant",
  ITEM_LIST: "item_list",
  CHECKOUT_STEP: "checkout_step",
  CHECKOUT_OPTION: "checkout_option",
  CREATIVE_NAME: "creative_name",
  CREATIVE_SLOT: "creative_slot",
  AFFILIATION: "affiliation",
  INDEX: "index",
  DISCOUNT: "discount",
  ITEM_CATEGORY2: "item_category2",
  ITEM_CATEGORY3: "item_category3",
  ITEM_CATEGORY4: "item_category4",
  ITEM_CATEGORY5: "item_category5",
  ITEM_LIST_ID: "item_list_id",
  ITEM_LIST_NAME: "item_list_name",
  ITEMS: "items",
  LOCATION_ID: "location_id",
  PAYMENT_TYPE: "payment_type",
  PROMOTION_ID: "promotion_id",
  PROMOTION_NAME: "promotion_name",
  SCREEN_CLASS: "screen_class",
  SCREEN_NAME: "screen_name",
  SHIPPING_TIER: "shipping_tier"
};

var populateItems = function populateItems(array, items, price) {
  array === null || array === void 0 ? void 0 : array.forEach(function (product) {
    // const obj = { ...product, detailLink: "" };
    var obj = {};
    obj[FirebaseParams.ITEM_NAME] = product === null || product === void 0 ? void 0 : product.name;
    obj[FirebaseParams.ITEM_CATEGORY] = product === null || product === void 0 ? void 0 : product.category;
    obj[FirebaseParams.CURRENCY] = "USD";
    obj[FirebaseParams.QUANTITY] = product === null || product === void 0 ? void 0 : product.quantity;
    obj['revenue'] = product === null || product === void 0 ? void 0 : product.price;
    obj['price'] = product === null || product === void 0 ? void 0 : product.price;
    obj['value'] = product === null || product === void 0 ? void 0 : product.price;

    if (Number.isInteger(product === null || product === void 0 ? void 0 : product.price)) {
      price += product === null || product === void 0 ? void 0 : product.price;
    } else {
      var _product$price, _product$price$toStri;

      price += Number(product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$toStri = _product$price.toString()) === null || _product$price$toStri === void 0 ? void 0 : _product$price$toStri.replace("$", ""));
    }

    items.push(obj);
  });
  return price;
};

export var firebaseUtil = {
  createItemFromProduct: function createItemFromProduct(product) {
    var _product$DisplayName, _product$CatalogName;

    return firebaseUtil.createItemObject((_product$DisplayName = product === null || product === void 0 ? void 0 : product.DisplayName) !== null && _product$DisplayName !== void 0 ? _product$DisplayName : product === null || product === void 0 ? void 0 : product.displayName, (_product$CatalogName = product === null || product === void 0 ? void 0 : product.CatalogName) !== null && _product$CatalogName !== void 0 ? _product$CatalogName : product === null || product === void 0 ? void 0 : product.catalogName);
  },
  createItemsFromCartLines: function createItemsFromCartLines(cartLineArrays) {
    var array = Array.isArray(cartLineArrays) ? cartLineArrays : [cartLineArrays];

    for (var i = 0; i < cartLineArrays.length; i++) {
      var _line$Product;

      var line = cartLineArrays[i];
      var item = firebaseUtil.createItemFromProduct((_line$Product = line === null || line === void 0 ? void 0 : line.Product) !== null && _line$Product !== void 0 ? _line$Product : line === null || line === void 0 ? void 0 : line.product);
      array.push(item);
    }

    return array;
  },
  addToCart: function addToCart(currency, value, items) {
    var bundle = {};
    bundle[FirebaseParams.CURRENCY] = currency;
    bundle[FirebaseParams.VALUE] = value;
    bundle[FirebaseParams.ITEMS] = items;
    mobileAppUtil.mobileGALogEvent(FirebaseEvents.ADD_TO_CART, bundle);
  },
  removeFromCart: function removeFromCart(currency, value, items) {
    var bundle = {};
    bundle[FirebaseParams.CURRENCY] = currency;
    bundle[FirebaseParams.VALUE] = value;
    bundle[FirebaseParams.ITEMS] = items;
    mobileAppUtil.mobileGALogEvent(FirebaseEvents.REMOVE_FROM_CART, bundle);
  },
  beginCheckout: function beginCheckout(currency, value, coupon, items) {
    var bundle = {};
    bundle[FirebaseParams.CURRENCY] = currency;
    bundle[FirebaseParams.VALUE] = value;
    bundle[FirebaseParams.COUPON] = coupon;
    bundle[FirebaseParams.ITEMS] = items;
    mobileAppUtil.mobileGALogEvent(FirebaseEvents.BEGIN_CHECKOUT, bundle);
  },
  purchase: function purchase(transactionId, affiliation, currency, value, tax, shipping, coupon, items) {
    var bundle = {};
    bundle[FirebaseParams.TRANSACTION_ID] = transactionId;
    bundle[FirebaseParams.AFFILIATION] = affiliation;
    bundle[FirebaseParams.CURRENCY] = currency;
    bundle[FirebaseParams.VALUE] = value;
    bundle[FirebaseParams.TAX] = tax;
    bundle[FirebaseParams.SHIPPING] = shipping;
    bundle[FirebaseParams.COUPON] = coupon;
    bundle[FirebaseParams.ITEMS] = items;
    mobileAppUtil.mobileGALogEvent(FirebaseEvents.PURCHASE, bundle);
  },
  viewProductDetail: function viewProductDetail(currency, value, items) {
    var bundle = {};
    bundle[FirebaseParams.CURRENCY] = currency;
    bundle[FirebaseParams.VALUE] = value;
    bundle[FirebaseParams.ITEMS] = items;
    mobileAppUtil.mobileGALogEvent(FirebaseEvents.VIEW_ITEM, bundle);
  },
  convertToFirebaseEvent: function convertToFirebaseEvent(obj) {
    var _ecommerceObj$add, _ecommerceObj$add2, _ecommerceObj$checkou, _ecommerceObj$checkou2, _ecommerceObj$detail, _ecommerceObj$remove, _ecommerceObj$remove2, _ecommerceObj$purchas, _ecommerceObj$purchas2, _ecommerceObj$purchas3, _ecommerceObj$purchas4, _ecommerceObj$purchas5, _ecommerceObj$purchas6, _ecommerceObj$purchas7, _ecommerceObj$purchas8, _ecommerceObj$purchas9, _ecommerceObj$purchas10, _ecommerceObj$purchas11, _ecommerceObj$purchas12, _ecommerceObj$purchas13;

    try {
      var eventName = obj.event;
      var ecommerceObj = obj.ecommerce;
      var items = [];
      var price = 0.0;

      switch (eventName) {
        case "addToCart":
          price = populateItems(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$add = ecommerceObj.add) === null || _ecommerceObj$add === void 0 ? void 0 : _ecommerceObj$add.products, items, price);
          firebaseUtil.addToCart(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$add2 = ecommerceObj.add) === null || _ecommerceObj$add2 === void 0 ? void 0 : _ecommerceObj$add2.currencyCode, price, items);
          break;

        case "productImpression":
          // 6.32.0 - [Firebase/Analytics][I-ACS013013] Only ecommerce events are allowed to contain array parameters. Invalid ecommerce name: productImpression
          // mobileAppUtil.mobileGALogEvent(eventName, ecommerceObj);
          break;

        case "checkout":
          if ((ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$checkou = ecommerceObj.checkout) === null || _ecommerceObj$checkou === void 0 ? void 0 : (_ecommerceObj$checkou2 = _ecommerceObj$checkou.actionField) === null || _ecommerceObj$checkou2 === void 0 ? void 0 : _ecommerceObj$checkou2.step) === 1) {
            var _ecommerceObj$checkou3;

            price = populateItems(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$checkou3 = ecommerceObj.checkout) === null || _ecommerceObj$checkou3 === void 0 ? void 0 : _ecommerceObj$checkou3.products, items, price);
            firebaseUtil.beginCheckout("USD", price, "", items);
          }

          break;

        case "productClick":
          // code block
          mobileAppUtil.mobileGALogEvent(eventName, ecommerceObj);
          break;

        case "productDetail":
          price = populateItems(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$detail = ecommerceObj.detail) === null || _ecommerceObj$detail === void 0 ? void 0 : _ecommerceObj$detail.products, items, price);
          firebaseUtil.viewProductDetail("USD", price, items);
          break;

        case "editInCart":
          mobileAppUtil.mobileGALogEvent(eventName, ecommerceObj);
          break;

        case "removeFromCart":
          price = populateItems(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$remove = ecommerceObj.remove) === null || _ecommerceObj$remove === void 0 ? void 0 : _ecommerceObj$remove.products, items, price);
          firebaseUtil.removeFromCart(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$remove2 = ecommerceObj.remove) === null || _ecommerceObj$remove2 === void 0 ? void 0 : _ecommerceObj$remove2.currencyCode, price, items);
          break;

        case "purchaseConfirmation":
          price = populateItems(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas = ecommerceObj.purchase) === null || _ecommerceObj$purchas === void 0 ? void 0 : _ecommerceObj$purchas.products, items, price);
          var transId = ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas2 = ecommerceObj.purchase) === null || _ecommerceObj$purchas2 === void 0 ? void 0 : (_ecommerceObj$purchas3 = _ecommerceObj$purchas2.actionField) === null || _ecommerceObj$purchas3 === void 0 ? void 0 : _ecommerceObj$purchas3.id; // console.log('purchaseConfirmation object ',ecommerceObj)

          var affiliation = ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas4 = ecommerceObj.purchase) === null || _ecommerceObj$purchas4 === void 0 ? void 0 : (_ecommerceObj$purchas5 = _ecommerceObj$purchas4.actionField) === null || _ecommerceObj$purchas5 === void 0 ? void 0 : _ecommerceObj$purchas5.affiliation;
          var code = ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas6 = ecommerceObj.purchase) === null || _ecommerceObj$purchas6 === void 0 ? void 0 : (_ecommerceObj$purchas7 = _ecommerceObj$purchas6.actionField) === null || _ecommerceObj$purchas7 === void 0 ? void 0 : _ecommerceObj$purchas7.CurrencyCode;
          var total = Number(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas8 = ecommerceObj.purchase) === null || _ecommerceObj$purchas8 === void 0 ? void 0 : (_ecommerceObj$purchas9 = _ecommerceObj$purchas8.actionField) === null || _ecommerceObj$purchas9 === void 0 ? void 0 : _ecommerceObj$purchas9.Total);
          var tax = Number(ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas10 = ecommerceObj.purchase) === null || _ecommerceObj$purchas10 === void 0 ? void 0 : (_ecommerceObj$purchas11 = _ecommerceObj$purchas10.actionField) === null || _ecommerceObj$purchas11 === void 0 ? void 0 : _ecommerceObj$purchas11.tax);
          var shipping = ecommerceObj === null || ecommerceObj === void 0 ? void 0 : (_ecommerceObj$purchas12 = ecommerceObj.purchase) === null || _ecommerceObj$purchas12 === void 0 ? void 0 : (_ecommerceObj$purchas13 = _ecommerceObj$purchas12.actionField) === null || _ecommerceObj$purchas13 === void 0 ? void 0 : _ecommerceObj$purchas13.ShippingTotal;
          var coupon = ""; // ecommerceObj?.purchase?.actionField?.TotalSavings?.toString()?.replace("$", "")

          mobileAppUtil.firebaseUtil.purchase(transId, affiliation, code, total, tax, shipping, coupon, items);
          break;

        default:
          // code block
          break;
      }
    } catch (exception) {
      console.error(exception);
    }
  }
};
export var mobileAppUtil = {
  FirebaseParams: FirebaseParams,
  firebaseEvents: FirebaseEvents,
  firebaseUtil: firebaseUtil,
  getMobileLocation: function getMobileLocation() {
    // if(window.CapacitorGetLocation){
    //   const position = window.CapacitorGetLocation().coords
    //   console.log(position)
    //   return position
    // }
    var key = "mobile-app-state";
    var mobileAppState = JSON.parse(window.sessionStorage.getItem(key));
    return mobileAppState === null || mobileAppState === void 0 ? void 0 : mobileAppState.location;
  },
  isMobileApp: function isMobileApp() {
    var key = "mobile-app-state";
    var value = window.sessionStorage.getItem(key);
    if (value == null) return false;
    var mobileAppState = JSON.parse(value);
    if (mobileAppState == null) return false;
    return true;
  },
  isiOS: function isiOS() {
    var key = "mobile-app-state";
    var mobileAppState = JSON.parse(window.sessionStorage.getItem(key));
    return (mobileAppState === null || mobileAppState === void 0 ? void 0 : mobileAppState.isiOS) || false;
  },
  mobileGALogEvent: function mobileGALogEvent(eventName, bundle) {
    try {
      if (window.mobileGALogEvent) {
        console.log("logging GA Event for mobile ", eventName, bundle);
        window.mobileGALogEvent(eventName, bundle);
      }
    } catch (error) {
      console.log("failed to log GA event for mobile ", error);
    }
  }
};